<ndt-location-detail-view
   [location]="location$ | async"
   [locationPrivileges]="locationPrivileges$ | async"
   [callState]="callState$ | async"
   [isSystemUser]="isSystemUser$ | async"
   [selectedAccountName]="selectedAccount$ | async"
   (formSaveCanceled)="onFormSaveCanceled()"
   (deleteLocation)="onDeleteLocation($event)"
   (formSubmitted)="onFormSubmitted($event)"
></ndt-location-detail-view>
